<div class="iframe-container embed-responsive h-90" >
	<iframe allowfullscreen class="embed-responsive-item" [src]="link" ></iframe>
</div>
